module.exports = __webpack_public_path__ + "static/media/Vector3.253598bd.svg";